import { ROUTE_CHECKOUT } from '../constants';

const PULSE_CHECKOUT_SESSION_KEY = 'pulse_checkout_session';
const PULSE_CHECKOUT_STARTED_PENDING_KEY = 'pulse_checkout_started_pending';

type PulseCheckoutSession = {
  cartId: string;
  checkoutId: string;
};

/** Tab-scoped arm/disarm for checkout_started (sessionStorage, not shared across tabs). */
export const isCheckoutStartedPending = (): boolean => {
  try {
    return sessionStorage.getItem(PULSE_CHECKOUT_STARTED_PENDING_KEY) === '1';
  } catch (_) {
    return false;
  }
};

export const armCheckoutStarted = (): void => {
  try {
    if (
      typeof window !== 'undefined' &&
      window.location.pathname.includes(ROUTE_CHECKOUT)
    ) {
      return;
    }
    sessionStorage.setItem(PULSE_CHECKOUT_STARTED_PENDING_KEY, '1');
  } catch (_) {}
};

export const disarmCheckoutStarted = (): void => {
  try {
    sessionStorage.setItem(PULSE_CHECKOUT_STARTED_PENDING_KEY, '0');
  } catch (_) {}
};

/** Spec: `concat(cart_id, unix_timestamp)` (seconds). */
export const buildCheckoutId = (
  cartId: string | number | null | undefined,
  unixTimestampSec: number = Math.floor(Date.now() / 1000)
): string | null => {
  if (cartId == null || String(cartId) === '') return null;
  return `${cartId}${unixTimestampSec}`;
};

export const rememberCheckoutIdForCart = (
  cartId: string | number | null | undefined,
  checkoutId: string | null
): void => {
  if (!checkoutId || cartId == null || String(cartId) === '') return;
  try {
    sessionStorage.setItem(
      PULSE_CHECKOUT_SESSION_KEY,
      JSON.stringify({
        cartId: String(cartId),
        checkoutId,
      } satisfies PulseCheckoutSession)
    );
  } catch (_) {
    // sessionStorage unavailable
  }
};

/** Reuse checkout_id from checkout_started when cart matches; else build fresh. */
export const resolveCheckoutIdForPurchase = (
  cartId: string | number | null | undefined
): string | null => {
  if (cartId == null || String(cartId) === '') return null;
  try {
    const raw = sessionStorage.getItem(PULSE_CHECKOUT_SESSION_KEY);
    if (raw) {
      const session = JSON.parse(raw) as PulseCheckoutSession;
      if (session.cartId === String(cartId) && session.checkoutId) {
        return session.checkoutId;
      }
    }
  } catch (_) {}
  return buildCheckoutId(cartId);
};

export const clearCheckoutIdSession = (): void => {
  try {
    sessionStorage.removeItem(PULSE_CHECKOUT_SESSION_KEY);
  } catch (_) {}
};
